enum CreditsActionTypesEnum {
  SAVE_CLUSTERS = 'SAVE_CLUSTERS',
  SAVE_MARKETPLACES = 'SAVE_MARKETPLACES',
  SET_SELECTED_MARKETPLACE = 'SET_SELECTED_MARKETPLACE',
  SAVE_CUSTOMERS = 'SAVE_CUSTOMERS',
  SAVE_VAR_CUSTOMERS = 'SAVE_VAR_CUSTOMERS',
  SET_SELECTED_DETAILED_CUSTOMER = 'SET_SELECTED_DETAILED_CUSTOMER',
  SAVE_WALLETS = 'SAVE_WALLETS',
  APPEND_WALLET = 'APPEND_WALLET',
  UPDATE_WALLET = 'UPDATE_WALLET',
  SET_SELECTED_WALLET = 'SET_SELECTED_WALLET',
  SAVE_MARKETPLACE_SUBSCRIPTIONS = 'SAVE_MARKETPLACE_SUBSCRIPTIONS',
  SET_SELECTED_MARKETPLACE_MAIN_TIER = 'SET_SELECTED_MARKETPLACE_MAIN_TIER_SUBSCRIPTION',
  SAVE_SELECTED_MARKETPLACE_MAIN_TIER_SUBSCRIPTIONS = 'SAVE_SELECTED_MARKETPLACE_MAIN_TIER_SUBSCRIPTIONS',
  SAVE_SYSTEM_CARDS = 'SAVE_SYSTEM_CARDS',
  SET_SELECTED_WALLET_PLANT = 'SET_SELECTED_WALLET_PLANT',
  SAVE_WALLETS_ALL = 'SAVE_WALLETS_ALL',
  SAVE_CUSTOMERS_SEARCH = 'SAVE_CUSTOMERS_SEARCH',
  SAVE_CUSTOMER_PLANTS = 'SAVE_CUSTOMER_PLANTS',
  SAVE_ALL_DOMAINS = 'SAVE_ALL_DOMAINS',
  SET_VAT_VERIFICATION_STATUS = 'SET_VAT_VERIFICATION_STATUS',
  SET_VAT_VERIFICATION_MONITOR_STATUS = 'SET_VAT_VERIFICATION_MONITOR_STATUS',
  SAVE_CUSTOMER_CONTRACTS = 'SAVE_CUSTOMER_CONTRACTS',
  SET_SELECTED_CUSTOMER_CONTRACT = 'SET_SELECTED_CUSTOMER_CONTRACT',
  SAVE_CUSTOMER_CONTRACT_SERVICES = 'SAVE_CUSTOMER_CONTRACT_SERVICES',
  SET_SELECTED_CUSTOMER_CONTRACT_SERVICE = 'SET_SELECTED_CUSTOMER_CONTRACT_SERVICE',
  SET_SELECTED_CUSTOMER_PLANT = 'SET_SELECTED_CUSTOMER_PLANT',
  LOAD_STATIC_SERVICES = 'LOAD_STATIC_SERVICES',
  SAVE_CUSTOMER_ALL_CONTRACT_SERVICES = 'SAVE_CUSTOMER_ALL_CONTRACT_SERVICES',
  SAVE_ALL_CUSTOMER_CONTRACTS = 'SAVE_ALL_CUSTOMER_CONTRACTS',
  SAVE_ALL_CUSTOMER_CONTRACT_SERVICES = 'SAVE_ALL_CUSTOMER_CONTRACT_SERVICES',
  SAVE_ALL_CUSTOMERS = 'SAVE_ALL_CUSTOMERS',
  SAVE_CUSTOMER_CONTRACT_NOTIFICATION_RULES = 'SAVE_CUSTOMER_CONTRACT_NOTIFICATION_RULES',
  SET_SELECTED_CUSTOMER_CONTRACT_NOTIFICATION_RULE = 'SET_SELECTED_CUSTOMER_CONTRACT_NOTIFICATION_RULE',
  SAVE_PERIODIC_DOMAINS = 'SAVE_PERIODIC_DOMAINS',
  SAVE_DEMO_PLANTS = 'SAVE_DEMO_PLANTS',
  SET_SELECTED_DEMO_PLANT = 'SET_SELECTED_DEMO_PLANT',
}

export default CreditsActionTypesEnum;
